import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { DataCardBone } from '../../organisms/DataCardBone/DataCardBone';

interface DataCardSkeletonProps {
    /** Afficher l'en-tête */
    header?: boolean;
    /** Afficher les contrôles */
    controllers?: boolean;
    /** Nombre de lignes de données */
    numberOfLines?: number;
    /** Nombre de statuts */
    numberOfStatus?: number;
    /** Nombre d'actions */
    numberOfActions?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const DataCardSkeleton: React.FunctionComponent<DataCardSkeletonProps> = function ({
    header = false,
    controllers = false,
    numberOfLines = 4,
    numberOfStatus = 3,
    numberOfActions = 2,
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                ...sx,
            }}
        >
            <DataCardBone
                showHeader={header}
                showControls={controllers}
                dataLines={numberOfLines}
                statusCount={numberOfStatus}
                actionCount={numberOfActions}
            />
        </Box>
    );
};
